import { render, staticRenderFns } from "./RequestViewBasedOn.vue?vue&type=template&id=034a0288"
import script from "./RequestViewBasedOn.vue?vue&type=script&lang=js"
export * from "./RequestViewBasedOn.vue?vue&type=script&lang=js"
import style0 from "./RequestViewBasedOn.vue?vue&type=style&index=0&id=034a0288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports